module.exports = __webpack_public_path__ + "img/icon-dropdown-orange.1413a81e.svg";